module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_2025_2026_new.1790230608476.png";